// extracted by mini-css-extract-plugin
module.exports = {"tags":"_21o59b","pre-order-text-only":"_2gEetE","pre-order":"_3DgndY"};